import React, { useState } from "react";
import { Table,Button, Tag } from "antd";
import {Row,Col} from 'react-bootstrap'
import { DownloadOutlined } from '@ant-design/icons';
import moment from "moment";

const BusinessesTable = (props) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([]); // Track expanded row

  const columns = [
    {
      title: "Subscriber ID",
      dataIndex: "userId",
      key: "userId",
      render: (userId, record) => {
        const createdAt = record?.createdAt;
        const isNew = moment().diff(moment(createdAt), 'hours') < 24;
        return (
          <div style={{display:'flex'}}>
          <p style={{ margin: 0 }}>{userId}</p>
          {isNew && (
            <Tag color="green" style={{ marginLeft: '5px' }}>
              New
            </Tag>
          )}
        </div>
        )
      }
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "Registered Date",
      key: "createdAt",
      render: (record) => (
        <span>{moment(record.createdAt).format("DD-MM-YYYY")}</span>
      ),
    },
    {
      title: "Email Id",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
  ];

  const handleExpand = (expanded, record) => {
    setExpandedRowKeys(expanded ? [record.id] : []); // Ensure only one row expands at a time
  };

  const handleDownload = (photoUrl) => {
    if (!photoUrl) return;
      const fixedUrl = photoUrl.startsWith("http://") || photoUrl.startsWith("https://")
      ? photoUrl
      : `https://${photoUrl}`;
  
    // Create a temporary invisible <a> tag to trigger download
    const link = document.createElement("a");
    link.href = fixedUrl;
    link.download = fixedUrl.split('/').pop(); // Sets the filename
    link.target = "_blank"; // Opens in new tab
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Cleanup
  };

  const handleBrochuresDownload = (brochureUrls = [])=>{
    if(!Array.isArray(brochureUrls) || brochureUrls.length === 0) return;

    brochureUrls.forEach((url)=>{
      if(!url) return 
      const fixedUrl = url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;

    const link = document.createElement("a");
    link.href = fixedUrl;
    link.download = fixedUrl.split('/').pop(); // Set file name from URL
    link.target = "_blank"; // Open/download in new tab
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    })

  }
  
  
  return (
    <Table
      columns={columns}
      dataSource={props.data}
      rowKey={(record) => record.id}
      pagination={!props.mini}
      expandable={{
        expandedRowRender: (record) => (
          <div style={{ paddingLeft: 24 }}>
            <Row>
              <Col md={6}>
                <p>Company Location: {record.location || "N/A"}</p>
                <p>Project Area: {record.projectArea || "N/A"}</p>
                <p>Project Type: {record.projectType || "N/A"}</p>
                <p>Project Value: {record.projectValue || "N/A"}</p>
                <p>Near by Location: {record.nearbyLocation || "N/A"}</p>
                <p>Amenities: {record.amenities || "N/A"}</p>
              </Col>
              <Col md={6}>
                <p>CMDA/Rera Approved: {record.cmdaReraApproved || "N/A"}</p>
                <p>States Name: 
                {Array.isArray(record.stateNames) && record.stateNames.length > 0 
                  ? record.stateNames.map((state, index) => (
                      <span key={index}>{state}<br /></span>
                    )) 
                  : "N/A"}
              </p> 
                <Button   onClick={() => handleDownload(record.projectPhoto)}
                 icon={<DownloadOutlined />} size='middle'>Project Photo Download</Button>   


                <Button   onClick={() => handleBrochuresDownload(record.brochureCreatives)}
                 icon={<DownloadOutlined />} size='middle'>Brochure Download</Button>   
             </Col>
            </Row>
          </div>
        ),
        rowExpandable: (record) => !!record.projectType, // Or any other relevant field
        expandedRowKeys,
        onExpand: handleExpand, // Control row expansion
      }}
    />
  );
};

export default BusinessesTable;



// import { Table, Button, Modal, Row, Col } from 'antd';
// import { useState } from 'react';
// import { Link } from 'react-router-dom';
// import RaiseDuplicateModal from '../Modals/RaiseDuplicateModal';
// import moment from 'moment';

// const BusinessesTable = (props) => {
//   const [recordId, setRecordId] = useState(null);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [confirmModalVisible, setConfirmModalVisible] = useState(false); // Add this line

//   const columns = [
//     {
//       title: 'Company Name',
//       dataIndex: 'companyName',
//       key: 'userId',
//     },
//     {
//       title: 'Registered Date',
//       key: 'userId',
//       render: (record) => (
//         <span>{moment(record.createdAt).format('DD-MM-YYYY')}</span>
//       ),
//     },
//     {
//       title: 'Email Id',
//       dataIndex: 'email',
//       key: 'userId',
//     },
//     {
//       title: 'Phone',
//       dataIndex: 'mobileNo',
//       key: 'userId',
//     },
//     // {
//     //   title: 'Action',
//     //   key: 'action',
//     //   render: (record) => (
//     //     <Button type="link" danger onClick={() => { setRecordId(record.id); setConfirmModalVisible(true) }}>
//     //       Block Business
//     //     </Button>
//     //   ),
//     // },
//   ];

//   const handleConfirm = () => {
//     // Add your code to block the business here
//     // For example, you can make an API call to update the business status in the database

//     setConfirmModalVisible(false);
//     setModalVisible(true);
//   };

//   return (
//     <div>
//       <Table
//         columns={columns}
//         dataSource={props.data}
//         key={record => record.id}
//         pagination={!props.mini}
//         expandable={props.expand ? {
//           expandedRowRender: (record) => (
//             <>
//              <div style={{display:'grid'}}>
//                 <span className="mb-2">Team strength : {record.teamStrength}</span>
//                 <span className="mb-2">Companay Location : {record.location}</span>
//                 <span className="mb-2">Companay Start date : {moment(record.startDate).format('DD-MM-YYYY') || 'no date'}</span>
//                 <span className="mb-2">GMB Profile url: {record.gmbProfileUrl}</span>
//               </div>
//             </>
//           ),
//         } : false}
//         footer={() => props.mini ? (
//           <tr>
//             <td colSpan={columns.length} style={{ textAlign: 'center' }}>
//               <Link to="/admin/businesses">View More</Link>
//             </td>
//           </tr>
//         ) : null}
//       />
//       {/* <Modal title="Block Business" visible={confirmModalVisible} onOk={handleConfirm}
//         onCancel={() => setConfirmModalVisible(false)}>
//         <p>Are you sure you want to block this business?</p>
//       </Modal> */}
//     </div>
//   );
// };

// export default BusinessesTable;